import { BatteryStatsCard } from '@/features/devices/components/BMS/battery-stats-card.tsx';
import { RealTimeBMSDataSection } from '@/features/devices/components/BMS/battery-live-data-card.tsx';
import { DeviceMetricsTableCard } from '@/features/devices/components/device-metrics-table/device-metrics-table-card.tsx';
import { useGetDeviceQuery } from '@/features/devices/hooks/queries/[device]/get-device.ts';
import { useOverviewDeviceQuery } from '@/features/devices/hooks/queries/[device]/get-device-overview.ts';
import { cn } from '@/utils/utils.ts';
import style from './bms-device.page.module.scss';

export function BmsDevicePage({ deviceId }: { deviceId: string | undefined }) {
  const { data: device, isLoading: isDeviceLoading } = useGetDeviceQuery({
    deviceId: deviceId ?? '',
  });

  const { data: deviceOverview, isLoading: isDeviceOverviewLoading } = useOverviewDeviceQuery({
    deviceId: deviceId ?? '',
  });

  const isLoading = isDeviceLoading || isDeviceOverviewLoading;

  return (
    <div className={cn(style.bms_device_page, 'flex flex-col gap-4')}>
      <div className={cn(style.bms_device_cards, '')}>
        <BatteryStatsCard deviceId={deviceId} className={style.bms_device_stats_card} />
        <RealTimeBMSDataSection deviceId={deviceId} />
      </div>
      <DeviceMetricsTableCard
        isLoading={isLoading}
        plantId={device?.plantId}
        data={deviceOverview?.device}
        deviceType={device?.type}
        deviceSN={device?.SN}
      />
    </div>
  );
}
